/**
 * Proyecto: MOGOTAX Conductor Web
 * Modal para mostrar observaciones/indicaciones del conductor completas.
 */
import React from "react";
import { Modal, Typography, Button, message } from "antd";
import {
  InfoCircleOutlined,
  CopyOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";

const { Text, Title } = Typography;

const ObservacionesModal = ({
  visible,
  onClose,
  titulo,
  contenido,
  icono: IconComponent = InfoCircleOutlined,
  iconColor = "#1890ff",
}) => {
  const handleCopiar = () => {
    navigator.clipboard.writeText(contenido);
    message.success("Texto copiado al portapapeles");
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title={null}
      footer={null}
      width={500}
      centered
      closable={false}
      bodyStyle={{ padding: 0 }}
    >
      {/* Encabezado */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px 20px",
          borderBottom: "1px solid #f0f0f0",
          backgroundColor: "#fafafa",
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 10,
            backgroundColor: `${iconColor}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: 12,
          }}
        >
          <IconComponent style={{ fontSize: 20, color: iconColor }} />
        </div>
        <Title level={5} style={{ margin: 0, flex: 1 }}>
          {titulo}
        </Title>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          style={{ color: "#8c8c8c" }}
        />
      </div>

      {/* Contenido */}
      <div style={{ padding: 20 }}>
        <div
          style={{
            padding: 16,
            backgroundColor: `${iconColor}08`,
            borderRadius: 12,
            border: `1px solid ${iconColor}20`,
          }}
        >
          <Text
            style={{
              fontSize: 15,
              lineHeight: 1.6,
              color: "#262626",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {contenido}
          </Text>
        </div>

        {/* Botón copiar */}
        <Button
          block
          icon={<CopyOutlined />}
          onClick={handleCopiar}
          style={{
            marginTop: 16,
            height: 44,
            borderRadius: 10,
          }}
        >
          Copiar texto
        </Button>
      </div>
    </Modal>
  );
};

ObservacionesModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  titulo: PropTypes.string.isRequired,
  contenido: PropTypes.string.isRequired,
  icono: PropTypes.elementType,
  iconColor: PropTypes.string,
};

export default ObservacionesModal;
